module.exports = __webpack_public_path__ + "static/media/skull-crossbones.5c526db9.svg";